import { capitalize } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import type { Option } from "types";
import { BooleanSwitchValue } from "consts/general";
import type { PaymentMethodSwitchComponentProps } from "./types";
import { useTypedSelector } from "hooks";
import { selectMerchantMethodPivotActiveDomain } from "features/general/selectors";

const PaymentMethodActivationSelector = ({
    paymentMethodSwitch,
    merchantMethod
}: PaymentMethodSwitchComponentProps) => {
    const merchantMethodPivotActiveDomainOptions = useTypedSelector(selectMerchantMethodPivotActiveDomain);

    const {
        paymentMethodState,
        onChange,
        onClick
    } = paymentMethodSwitch;

    const renderMenu = () => [
        {
            value: `${BooleanSwitchValue.Off}`,
            children: paymentMethodState.enabled
                ? 'Disable'
                : 'Disabled'
        },
        ...merchantMethodPivotActiveDomainOptions.map(({ id, name }: Option) => ({
            value: `${id}`,
            children: capitalize(name)
        }))
    ];

    const isAssignable = Number(merchantMethod.paymentMethodIsAssignable) === 1;
    const getValue = () => (isAssignable
        ? `${paymentMethodState.MOR}`
        : `${BooleanSwitchValue.Off}`) as number | "" | undefined;

    const getStyles = () => {
        if (!Object.is(getValue(), `${BooleanSwitchValue.Off}`)) {
            return {
                bgcolor: 'primary.main',
                color: '#fff',
                '& .MuiSvgIcon-root': {
                    color: '#fff'
                }
            };
        }
    };

    return (
        <Select
            value={getValue()}
            disabled={!isAssignable}
            onChange={onChange}
            onClick={onClick}
            size='small'
            sx={{
                ...getStyles(),
                maxWidth: 200,
                width: '100%',
                justifySelf: 'flex-end',
                mr: 2
            }}
        >
            {renderMenu()
                .map(({ value, ...props }) => (
                    <MenuItem
                        {...props}
                        key={value}
                        value={value}
                    />
                ))}
        </Select>
    );
};

export default PaymentMethodActivationSelector;
